import click from '@gojob/tracking/click';

import mixpanel from '../mixpanel';

const searchTracking = {
  submitJobSearch: () => {
    click({
      eventCategory: 'jobboard',
      eventAction: 'Submit search query',
      eventName: 'Submit search query from job board',
    });
    mixpanel.track('Submit job search');
  },
  clickOnJobResult: () => {
    click({
      eventCategory: 'jobboard',
      eventAction: 'Click on a job offer result',
      eventName: 'Click on a search result from job board',
    });
    mixpanel.track('Click on a search result');
  },
  clickOnJobApply: () => {
    click({
      eventCategory: 'offer-jobboard',
      eventAction: 'Try to apply from job board offer',
      eventName: 'Try to apply from job board offer after search',
    });
    mixpanel.track('Apply from job board offer');
  },
  noResultAfterSearch: () => {
    click({
      eventCategory: 'jobboard',
      eventAction: 'Get no search result',
      eventName: 'Get no search result',
    });
    mixpanel.track('Get no search result');
  },
};

export default searchTracking;
